import { render, staticRenderFns } from "./tblComponentsTable.vue?vue&type=template&id=0fb2eb42"
import script from "./tblComponentsTable.vue?vue&type=script&lang=js"
export * from "./tblComponentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports